import React from "react";
import useConfig from "../../hooks/useConfig";
import GenericHeader from "../Shared/GenericHeader";

const Shows = props => {
    let settings = useConfig(props.company);

    React.useEffect(() => {
        document.title = "List of Live Shows - INSIDE Live Show";
        if (!settings) return;
        window.insideStreamingContainerId = "insideStreamContainer";
        let script = document.createElement("script");
        script.src = settings.tagUrl;
        script.async = true;
        document.head.appendChild(script);

        if (typeof settings.customFrameCss === "function") {
            settings.customFrameCss();
        }

    }, [settings]);

    if (!settings) return null;

    return (
        <>
            {settings.customHeader 
                ? settings.customHeader()
                : <GenericHeader logo={settings.logo} />}
            <div id="insideStreamContainer"></div>
        </>
    )
}

export default Shows;